// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 33 32"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.5}
      d="M7.33366 11.9987V22.6654M13.3337 11.9987V22.6654M20.0003 11.9987V22.6654M26.0003 11.9987V22.6654M4.66699 24.7987L4.66699 25.8654C4.66699 26.6121 4.66699 26.9855 4.81232 27.2707C4.94015 27.5216 5.14412 27.7256 5.395 27.8534C5.68022 27.9987 6.05359 27.9987 6.80033 27.9987H26.5337C27.2804 27.9987 27.6538 27.9987 27.939 27.8534C28.1899 27.7256 28.3938 27.5216 28.5217 27.2707C28.667 26.9855 28.667 26.6121 28.667 25.8654V24.7987C28.667 24.052 28.667 23.6786 28.5217 23.3934C28.3938 23.1425 28.1899 22.9385 27.939 22.8107C27.6538 22.6654 27.2804 22.6654 26.5337 22.6654H6.80033C6.05359 22.6654 5.68022 22.6654 5.39501 22.8107C5.14412 22.9385 4.94015 23.1425 4.81232 23.3934C4.66699 23.6786 4.66699 24.052 4.66699 24.7987ZM16.2042 4.10157L6.33754 6.29416C5.74146 6.42662 5.44342 6.49285 5.22095 6.65313C5.02471 6.7945 4.87063 6.98659 4.77519 7.20881C4.66699 7.46076 4.66699 7.76607 4.66699 8.37669L4.66699 9.86539C4.66699 10.6121 4.66699 10.9855 4.81232 11.2707C4.94015 11.5216 5.14412 11.7256 5.395 11.8534C5.68022 11.9987 6.05359 11.9987 6.80033 11.9987H26.5337C27.2804 11.9987 27.6538 11.9987 27.939 11.8534C28.1899 11.7256 28.3938 11.5216 28.5217 11.2707C28.667 10.9855 28.667 10.6121 28.667 9.86539V8.37669C28.667 7.76607 28.667 7.46076 28.5588 7.20881C28.4634 6.98659 28.3093 6.7945 28.113 6.65313C27.8906 6.49285 27.5925 6.42662 26.9964 6.29416L17.1298 4.10157C16.9571 4.06319 16.8707 4.044 16.7835 4.03635C16.706 4.02955 16.628 4.02955 16.5505 4.03635C16.4633 4.044 16.3769 4.06319 16.2042 4.10157Z"
    />
  </svg>
);
const IconBankBuildingFinance = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconBankBuildingFinance;
